@if (view == 'Login') {
    <mat-card [style.background-color]="community?.login_card_background_color_hex"
              [style.color]="community?.login_card_text_color_hex"
              class="loginPage">
        @if (!initialLoad) {
            @if (companyImg) {
                <div class="w-100 flex-row align-items-center mt-10 loginLogoContainer">
                    <img [alt]="companyName + ' Logo'" [src]="companyImg" class="mx-auto logoBg loginLogo">
                </div>
            }
            <mat-card-content>
                <div [class.centering]="community?.retired_community"
                     [class.splitLogin]="community?.login_text && !community?.retired_community">
                    @if (community?.login_text) {
                        <div class="p-20 pb-0 flex-col flex-space-between loginText">
                            <div class="hideMobile">
                                @if (community?.login_text_rendered) {
                                    <div [innerHTML]="community?.login_text_rendered"></div>
                                }
                                @if (!community?.login_text_rendered) {
                                    {{ community?.login_text }}
                                }
                            </div>
                            @if (!community?.retired_community) {
                                <button (click)="this.goToRegister()"
                                        [appCustomButtonColours]="community?.registration_button_color_hex"
                                        class="w-100"
                                        color="primary"
                                        mat-raised-button>
                                    Register now
                                </button>
                            }
                        </div>
                    }
                    @if (!community?.retired_community) {
                        <div class="loginSection">
                            <h2>{{ community?.login_page_title_text?.trim() || 'Log in' }}</h2>
                            @if (community?.login_heading_help_text?.trim()) {
                                <p class="login-heading-help">{{ community?.login_heading_help_text }}</p>
                            }
                            @if (community?.login_text) {
                                <div class="flex-col flex-space-between hideDesktop">
                                    @if (community?.login_text_rendered) {
                                        <div [innerHTML]="community?.login_text_rendered"></div>
                                    }
                                    @if (!community?.login_text_rendered) {
                                        {{ community?.login_text }}
                                    }
                                </div>
                            }
                            <form [formGroup]="loginForm">
                                <mat-form-field appearance="outline" class="w-100" color="accent">
                                    <mat-label>Email address</mat-label>
                                    <input (keyup.enter)="passwordField.focus()" appAutofill formControlName="email"
                                           matInput autocomplete="username"
                                           type="email"/>
                                    @if (loginForm.controls['email'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                    @if (loginForm.controls['email'].hasError('email')) {
                                        <mat-error>
                                            Please enter a valid email address
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-100" color="accent">
                                    <mat-label>Password</mat-label>
                                    <input #passwordField (keyup.enter)="loginIfValid()"
                                           [type]="passwordType" appAutofill formControlName="password" matInput
                                           autocomplete="current-password"/>
                                    <button (click)="showPassword()"
                                            [matTooltip]="passwordType == 'password' ? 'Show password' : 'Hide password'"
                                            class="h-fit-content p0" mat-icon-button
                                            matSuffix
                                            type="button">
                                        @if (passwordType == 'password') {
                                            <mat-icon color="accent">remove_red_eye
                                            </mat-icon>
                                        }
                                        @if (passwordType == 'text') {
                                            <mat-icon color="accent">highlight_off</mat-icon>
                                        }
                                    </button>
                                    @if (loginForm.controls['password'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-checkbox color="accent" formControlName="keep_logged_in">
                                    Remember me
                                </mat-checkbox>
                            </form>
                            <div class="text-align-center mb-10">
                                <button (click)="this.view = 'Forgot'" mat-button>
                                    Forgot password?
                                </button>
                                <br>
                                @if (community && !community?.login_text) {
                                    <button (click)="this.goToRegister()"
                                            [appCustomButtonColours]="community?.registration_button_color_hex"
                                            mat-button class="w-100">
                                        Register
                                    </button>
                                }
                            </div>
                            <button (click)="login()" [appCustomButtonColours]="community?.login_button_color_hex"
                                    [disabled]="loginForm.invalid || loading"
                                    autofocus class="w-100" color="accent" mat-flat-button>
                                Log in
                                @if (loading) {
                                    <mat-icon>
                                        <mat-spinner color="accent"></mat-spinner>
                                    </mat-icon>
                                }
                            </button>
                            @if (SSOProviders.length == 1 && community) {
                                <div class="d-flex flex-col mt-10 w-100 align-items-center">
                                    <app-sso-buttons [providers]="SSOProviders" [community]="community.id"
                                                     [keepMeLoggedIn]="this.loginForm.value.keep_logged_in"/>
                                </div>
                            } @else if (SSOProviders.length > 0) {
                                <button class="w-100 mt-5" color="accent" mat-flat-button [disabled]="loading"
                                        (click)="ssoModal()">
                                    {{ community?.sso_sign_in_title_text ? community?.sso_sign_in_title_text : 'Other ways of logging in' }}
                                </button>
                            }
                        </div>
                    }
                </div>
            </mat-card-content>
        }
        @if (initialLoad) {
            <mat-progress-spinner class="loader mx-auto my-10" color="accent"
                                  mode="indeterminate"></mat-progress-spinner>
        }
    </mat-card>
}
@if (view == 'Forgot') {
    <mat-card [style.background-color]="community?.login_card_background_color_hex"
              [style.color]="community?.login_card_text_color_hex"
              class="forgotPanel loginPage">
        @if (companyImg) {
            <div class="w-100 flex-row align-items-center mt-10 loginLogoContainer">
                <img [alt]="companyName + ' Logo'" [src]="companyImg" class="mx-auto logoBg loginLogo">
            </div>
        }
        <mat-card-header>
            <mat-card-subtitle>
                <h3>Forgot Password</h3>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="requestPasswordForm">
                <mat-form-field appearance="outline" class="w-100" color="accent">
                    <mat-label>Email address</mat-label>
                    <input formControlName="email" matInput type="email" autocomplete="username"/>
                    @if (requestPasswordForm.controls['email'].hasError('required')) {
                        <mat-error>
                            This field is required
                        </mat-error>
                    }
                    @if (requestPasswordForm.controls['email'].hasError('email')) {
                        <mat-error>
                            Please enter a valid email address
                        </mat-error>
                    }
                </mat-form-field>
            </form>
            <button (click)="this.view = 'Login'" mat-button>
                Remembered your password?
            </button>
        </mat-card-content>
        <mat-card-actions class="text-center">
            <button (click)="passwordResetRequest()" [disabled]="requestPasswordForm.invalid || loading"
                    class="mx-auto"
                    color="accent" mat-flat-button>
                Recover password
                @if (loading) {
                    <mat-icon>
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                }
            </button>
        </mat-card-actions>
    </mat-card>
}
@if (view == 'Create') {
    <mat-card [style.background-color]="community?.login_card_background_color_hex"
              class="createCard">
        @if (community?.register_page_logo) {
            <div class="w-100 d-flex justify-content-center">
                <div class="w-100 flex-row align-items-center mt-10 registerLogoContainer">
                    <img [alt]="companyName + ' Logo'" [src]="community?.register_page_logo"
                         class=" mx-auto logoBg loginLogo">
                </div>
            </div>
        }
        <mat-card-title class="text-center">
            @if (community?.registration_page_title_text_rendered) {
                <div [innerHTML]="community?.registration_page_title_text_rendered"></div>
            }
            @if (!community?.registration_page_title_text_rendered) {
                <h1 class="registerTitle"> Join {{ companyName }}'s
                    Community</h1>
            }
            @if (community?.registration_heading_help_text?.trim()) {
                <p class="registration-heading-help">{{ community?.registration_heading_help_text }}</p>
            }
        </mat-card-title>
        <mat-card-content>
            <app-register [community]="community"></app-register>
        </mat-card-content>
    </mat-card>
}

@if (view == 'Code') {
    <mat-card [style.background-color]="community?.login_card_background_color_hex"
              class="loginPage">
        <mat-card-content>
            <div class="loginSection">
                @if (enteringVerificationEmail) {
                    <h2>Verify your email</h2>
                    <p>Enter your email address so we can verify it before completing sign in.</p>
                } @else {
                    <h2>A code has been sent to {{ sentTo?.email }}</h2>
                }
                @if (community?.mfa_tab_text && !enteringVerificationEmail) {
                    <div class="flex-col flex-space-between mb-15">
                        @if (community?.mfa_tab_text_rendered) {
                            <div [innerHTML]="community?.mfa_tab_text_rendered"></div>
                        } @else {
                            {{ community?.mfa_tab_text }}
                        }
                    </div>
                }
                <form [formGroup]="otpForm">
                    @if (enteringVerificationEmail) {
                        <mat-form-field appearance="outline" class="w-100" color="primary">
                            <mat-label>Email address</mat-label>
                            <input (keyup.enter)="finishLoginIfValid(verificationInvalid)"
                                   formControlName="email" autocomplete="email" matInput type="email"/>
                            @if (otpForm.controls['email'].hasError('required')) {
                                <mat-error>This field is required</mat-error>
                            }
                        </mat-form-field>
                    } @else {
                        <mat-form-field appearance="outline" class="w-100" color="primary">
                            <mat-label>Code</mat-label>
                            <input (keyup.enter)="finishLoginIfValid(verificationInvalid)"
                                   formControlName="code" autocomplete="one-time-code"
                                   inputmode="numeric" matInput type="text"/>
                            @if (otpForm.controls['code'].hasError('required')) {
                                <mat-error>This field is required</mat-error>
                            }
                        </mat-form-field>
                    }
                </form>
                <small>
                    Codes may take 1-2 minutes to arrive, please wait at least 30 secs before requesting a new one.
                </small>
            </div>
        </mat-card-content>
        <mat-card-actions class="text-center flex-row flex-space-around">
            <div>
                <button (click)="request2fa()" [disabled]="loading || timer > 0 || enteringVerificationEmail"
                        (keyup.enter)="request2fa()"
                        class="mx-auto my-10 mx-10"
                        color="accent" mat-flat-button type="button">
                    @if (timer) {
                        Code request available again in {{ timer }} seconds
                    }
                    @if (!timer) {
                        Re-Send Code
                    }
                </button>
            </div>
            <button (click)="finishLoginIfValid(verificationInvalid)"
                    [disabled]="verificationInvalid || loading"
                    class="mx-auto my-10 mx-10"
                    color="primary" mat-flat-button type="submit">
                {{ enteringVerificationEmail ? 'Send code' : 'Continue' }}
                @if (loading) {
                    <mat-icon>
                        <mat-spinner color="primary"></mat-spinner>
                    </mat-icon>
                }
            </button>
        </mat-card-actions>
    </mat-card>
}
